import { render, staticRenderFns } from "./CUTextField.vue?vue&type=template&id=19f8245b&scoped=true"
import script from "./CUTextField.vue?vue&type=script&lang=ts"
export * from "./CUTextField.vue?vue&type=script&lang=ts"
import style0 from "./CUTextField.vue?vue&type=style&index=0&id=19f8245b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8245b",
  null
  
)

export default component.exports